import { defineStore } from "pinia";
import piniaPersistConfig from "@/stores/helper/persist";

interface GlobalStoreState {
    isCollapse: boolean;
    pageLoading: boolean;
}

export interface GlobalStoreGetters {
    [key: string]: (state: GlobalStoreState) => unknown;
    getIsCollapse: (state: GlobalStoreState) => boolean;
    getPageLoading: (state: GlobalStoreState) => boolean;
}

export interface GlobalStoreActions {
    setIsCollapse: (value: boolean) => void;
    startLoading: () => void;
    stopLoading: () => void;
}

export type GlobalStore = GlobalStoreState & GlobalStoreGetters & GlobalStoreActions;

export const useGlobalStore = defineStore("zhongsheng-global", {
    // 修改默认值之后，需清除 localStorage 数据
    state: (): GlobalStoreState => ({
        // 折叠菜单
        isCollapse: false,
        // 页面首次接口请求展示loading（详情页、编辑页）
        pageLoading: false
    }),
    getters: {
        getIsCollapse: (state: GlobalStoreState) => state.isCollapse,
        getPageLoading: (state: GlobalStoreState) => state.pageLoading
    },
    actions: {
        // 修改折叠菜单
        setIsCollapse(value: boolean) {
            this.isCollapse = value;
        },
        startLoading() {
            this.pageLoading = true;
        },
        stopLoading() {
            this.pageLoading = false;
        }
    } as GlobalStoreActions & ThisType<GlobalStore>,
    persist: piniaPersistConfig("zhongsheng-global")
});
